import { useStorage } from '@vueuse/core';
import { watch } from 'vue';
import { clearTenantListCache, TENANT_LIST_SESSION_KEY } from '@/utils/tenantListCache';

const TokenKey = 'Admin-Token';
const SCOPE_SWITCH_RECENT_KEY_PREFIX = 'scope-switch-recent:';
// 跨租户后用户标识可能变化，历史统一归属登录会话，不按视角内的用户标识拆分。
export const SCOPE_SWITCH_RECENT_KEY = `${SCOPE_SWITCH_RECENT_KEY_PREFIX}current`;

const tokenStorage = useStorage<null | string>(TokenKey, null);

// 其他标签页退出或更换账号时，同步清理本标签页持有的列表。
watch(tokenStorage, clearTenantListCache, { flush: 'sync' });

export const getToken = () => tokenStorage.value;

const clearScopeSwitchHistory = () => {
  try {
    // 记录只属于当前登录会话，刷新和切换视角保留，重新登录或退出时清空。
    Object.keys(localStorage)
      .filter((key) => key.startsWith(SCOPE_SWITCH_RECENT_KEY_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    // 浏览器禁用存储时不阻断认证流程。
  }
};

export const setToken = (access_token: string) => {
  clearScopeSwitchHistory();
  try {
    // 只保存非敏感的会话标识，让休眠标签页也能识别重新登录。
    localStorage.setItem(TENANT_LIST_SESSION_KEY, `${Date.now()}-${Math.random()}`);
  } catch {
    // 存储不可用时仍通过内存和 token 监听清理列表。
  }
  clearTenantListCache();
  tokenStorage.value = access_token;
};

export const removeToken = () => {
  clearScopeSwitchHistory();
  try {
    localStorage.removeItem(TENANT_LIST_SESSION_KEY);
  } catch {
    // 不影响退出和内存缓存清理。
  }
  clearTenantListCache();
  tokenStorage.value = null;
};
